export const templateConfigsColumnsData = {
  name: {
    title: "reportsTableColumns.name",
    width: "20%",
  },
  templateId: {
    title: "reportsTableColumns.templateId",
    width: "20%",
  },
  reportType: {
    title: "reportsTableColumns.reportType",
    width: "20%",
  },
  reportCategory: {
    title: "reportsTableColumns.reportCategory",
    width: "20%",
  },
  carboneType: {
    title: "reportsTableColumns.carboneType",
    width: "15%",
  },
  isDefault: {
    title: "reportsTableColumns.isDefault",
    width: "20%",
  },
  visible: {
    title: "reportsTableColumns.visible",
    width: "15%",
  },
  actions: {
    title: "reportsTableColumns.actions",
    width: "5%",
  },
};

export const initialTemplateConfigFormikValues = {
  id: null,
  name: null,
  templateId: null,
  reportType: null,
  isDefault: null,
};

export const isDefaultOptions = [
  { value: true, label: "Default" },
  { value: false, label: "Not Default" },
];

export const visibleOptions = [
  { value: true, label: "Visible" },
  { value: false, label: "Hidden" },
];

export const carboneTypeOptions = [
  { value: "ON_PREM", label: "On Prem" },
  { value: "CLOUD", label: "Cloud" },
  { value: "LOCAL", label: "Local" },
];
